export default () => window.innerWidth <= 767;
